import { Component, inject, signal } from '@angular/core';
import { TabComponent } from '../../../components/tab/tab.component';
import { TabLayoutComponent } from "../../../components/tab-layout/tab-layout.component";
import { APITableComponent } from '../../../components/table/api-table/api-table.component';
import { EvaluationService } from '../../../services/evaluation.service';
import { RadarChart, RadarChartComponent } from '../../../components/radar-chart/radar-chart.component';
import { TableResponse, TableRow } from '../../../components/table/table.interface';
import { ModalComponent } from "../../../components/modal/modal.component";
import { RepDatesAnalyticsComponent } from './rep-dates-analytics/rep-dates-analytics.component';

interface UserEvaluation {
  date: string;
  data: RadarChart;
}

@Component({
  selector: 'app-evaluations-tab',
  imports: [TabLayoutComponent, APITableComponent, ModalComponent, RadarChartComponent, RepDatesAnalyticsComponent],
  providers: [{ provide: TabComponent, useExisting: EvaluationsTabComponent }],
  templateUrl: './evaluations-tab.component.html',
  styleUrl: './evaluations-tab.component.scss',
})
export class EvaluationsTabComponent extends TabComponent {
  override name = this.dictionaryService.get('Evaluation');
  evaluationService = inject(EvaluationService);
  override async main(): Promise<void> { }
  repData: { date: string, data: RadarChart }[] = [];
  repName: string = '';
  totalData: RadarChart = {};
  isModalOpen = signal<boolean>(false);

  openUserEvaluation = (row: TableRow) => {
    const repId = row.value['repId'] as string;
    this.repName = row.value['Name'] as string;
    this.evaluationService.getUserEvaluation(repId).subscribe((res: TableResponse) => {
      const userEval = this.extractUserEvaluation(res);
      this.repData = userEval.filter(entry => entry.date !== "Average Scores") || [];
      const totalEntry = userEval.find(entry => entry.date === "Average Scores");

      this.totalData = totalEntry ? totalEntry.data : {};
      this.isModalOpen.set(true);
    })
  }

  private extractUserEvaluation = (res: TableResponse): UserEvaluation[] => {
    return res.data.rows.map((entry: any) => ({
      date: entry.Date,
      data: Object.fromEntries(
        Object.entries(entry).filter(([key]) => key !== 'Date'),
      ) as RadarChart,
    }));
  }

  onModalClose = () => {
    this.isModalOpen.set(false);
    this.repData = [];
  }

}
